import { Injectable } from '@angular/core';

import {SharedHttpService} from './shared-http.service';

@Injectable({
  providedIn: 'root'
})
export class PrintDesionService {

  decsionTypeId: number;
  decisionTypeName: any;
  DecsionOList: any;
  decsionId: any;
  constructor(private sharedService: SharedHttpService) { }


  convertNumerals(input: string) {
      return input.toString().split('0').join( '٠')
                      .split('1').join( '١')
                      .split('2').join( '٢')
                      .split('3').join( '٣')
                      .split('4').join( '٤')
                      .split('5').join( '٥')
                      .split('6').join( '٦')
                      .split('7').join( '٧')
                      .split('8').join( '٨')
                      .split('9').join( '٩');
  }

  PrintDecision(finishcaseIdEncrypt) {
    let getUrl: any = `api/Decsion/GetCaseDecsion?eCaseId=${finishcaseIdEncrypt}`;
    this.sharedService.get(getUrl).subscribe(result => {
      console.log("Decsion", result);
      this.DecsionOList = result;
        if (this.DecsionOList != null) {
            this.decsionId = result.decsionTypeId;
            if (this.decsionTypeId == 1) {
                this.sharedService.get(`api/Case/GetCaseDetails?eCaseId=${finishcaseIdEncrypt}`).subscribe((res) => {
                    console.log("CaseDetails", res);
                });
            }
            this.decsionTypeId = (result.decsionTypeId != null) ? result.decsionTypeId : "";
            if (result.decsionTypeId == 1) {
                this.decisionTypeName = "عدم ثبوت المخالفة";
            }
            if (result.decsionTypeId == 2) {
                this.decisionTypeName = "ثبوت المخالفة";
            }
        }
    });



    this.sharedService.get(`api/Case/GetPrint?caseEncryptedId=${finishcaseIdEncrypt}`).subscribe(res=>{
      let offenderTypeName;
      let penalities='';
      let memeberUser:any[]=[];
      let headOfCommittee;
      let signatureMemberOne;
      let signatureMemberTwo='';
      let SignatueHead='';
      let displayNameOne='';
      let displayNameTwo='';
      let memberOne='';
      let memberTwo='';
      let penalitiesprintArr=[];

      res.case.offenderTypeId == 1 ? offenderTypeName = "سجل تجاري رقم" : offenderTypeName = "رقم الهوية";
      res.case.reasons = ((res.case.reasons == null || res.case.reasons =="null") ? "" : res.case.reasons);
      res.case.facts = ((res.case.facts == null || res.case.facts=="null") ? "" : res.case.facts);
      res.penalites.map((el, index) => {
        if(el.isFinancial){
            penalitiesprintArr.push(el);
        }
      });
      if(this.decsionTypeId==1){
        penalities='';
      }else{
        if (penalitiesprintArr.length > 0) {
          penalities = `<h3 style="page-break-before: always;color: #00524D; margin-bottom: 16px; font-size: 20px ; line-height: 28px; ">بيانات السداد</h3>
                          <div style="overflow-x: auto;">
                              <table style="border-radius: 10px; min-width: 100%; border-collapse: collapse;">
                                  <thead  >
                                      <tr style="border-bottom: 1px solid #e2dfdf; background-color: #f9f9f9;">
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">نوع العقوبة</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">قيمة العقوبة</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">رقم السداد</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">الاسم</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">رقم الهوية</th>
                                      </tr>
                                  </thead>
                                  <tbody style="background-color: #f9f9f9;">
                                      `;
          let idx : any= 0;
          penalitiesprintArr.map((el, index) => {
              let nidtypename = '';
              let offendername = '';
              if (el.caseOffenderTypeId == 1) {
                  nidtypename = 'سجل تجاري : ';
                  offendername = res.case.offenderName;
              }
              else {
                nidtypename = 'رقم هوية : ';
                offendername = el.caseOffenderName;
              }
              idx = idx + 1;
              penalities = penalities.concat(`<tr >
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${el.isFinancial? 'مالية' : 'إدارية'}</td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${el.isFinancial? this.convertNumerals(el.amount)+'ريال' : '-'} </td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${el.isFinancial? el.sadadNumber : '-'}</td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${offendername}</td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${this.convertNumerals(el.offenderIdentity)}</td>
                  </tr>
              `);

          });
          penalities = penalities + "</tbody></table></div>"
        }
      }
      res.users.map(el =>{
        el.committeeRoleId == 7 ? memeberUser.push(el) : headOfCommittee = el;
      })
      if (res.decsion.decsion == null) {
          res.decsion.decsion = "";
      }
      if(memeberUser.length >=1){
        memeberUser[0].signture ? signatureMemberOne = `<img style='width:200px;height:50px; margin:auto;' src='data:image/png;base64,${memeberUser[0].signture}'/>` : signatureMemberOne = '';
        if (signatureMemberOne == undefined || signatureMemberOne == 'undefined') {
            signatureMemberOne = "";
        }
        displayNameOne = memeberUser[0].displayName;
        if (displayNameOne == undefined || displayNameOne == 'undefined') {
            displayNameOne = "";
        }
        if(signatureMemberOne !== "" && displayNameOne!== "" ){
            memberOne=`
                <h3 style="margin-bottom: 16px; font-size: 20px ; line-height: 28px; color: rgb(75 85 99);" >عضو</h3>
                ${signatureMemberOne}
                <p>${displayNameOne}</p>
            `;
        }
      }
      else {
        signatureMemberOne = "";
        displayNameOne = "";
      }
      if(memeberUser.length >=2){
        memeberUser[1].signture ? signatureMemberTwo = `<img style='width:250px;height:50px;margin:auto;' src='data:image/png;base64,${memeberUser[1].signture}'/>` : signatureMemberTwo = '';
        if (signatureMemberTwo == undefined || signatureMemberTwo == 'undefined') {
            signatureMemberTwo = "";
        }
        displayNameTwo = memeberUser[1].displayName;
        if (displayNameTwo == undefined || displayNameTwo == 'undefined') {
            displayNameTwo = "";
        }
        if(signatureMemberTwo !== "" && displayNameTwo!== "" ){
            memberTwo=`
                <h3 style="margin-bottom: 16px; font-size: 20px ; line-height: 28px; color: rgb(75 85 99);" >عضو</h3>
                ${signatureMemberTwo}
                <p>${displayNameTwo}</p>
            `;
        }
      }
      else {
        signatureMemberTwo = "";
        displayNameTwo = "";
      }
      headOfCommittee.signture ? SignatueHead=`<img style='width:200px;height:50px;margin:auto;' src='data:image/png;base64,${headOfCommittee.signture}'/>` : SignatueHead='';
      
      const body = `<div style="display:flex;justify-content: center;align-items: center; min-height:100vh">
      <div style="background-color:white; width: 100%;">
          <div style="display:flex;justify-content: space-between;align-items: center; margin-bottom: 1.5rem;">
              <div style="text-align:right" >
                  <p style="font-size: 14px; color: rgb(107 114 128); line-height:10px; font-weight:600 " >المملكة العربية السعودية</p>
                  <p style="font-size: 14px; color: rgb(107 114 128);font-weight:600" >وزارة التجارة</p>
              </div>
              <div>
                  <img src="../../../../../assets/images/printlogo.png" alt="Ministry of Commerce Logo" class="w-40">
              </div>
              <div>
                  <p style="font-size: 14px; color: rgb(107 114 128); line-height:15px; font-weight:600"> تاريخ القرار: ${res.decsion.decsionDate}</p>
                  <p style="font-size: 14px; color: rgb(107 114 128); line-height:15px; font-weight:600">رقم القرار: (${res.decsion.decsionNumber}/${res.decsion.hijriYear})</p>
                  <p style="font-size: 14px; color: rgb(107 114 128); line-height:15px; font-weight:600">المخالفة رقم: (${res.case.caseNumber})</p>
              </div>
          </div>

          <fieldset style="border: #00524D solid 3px; padding: 3px !important; border-radius: inherit;">
              <legend style="text-align: center; font-size: 24px; line-height: 32px ; padding-left: 36px ; padding-right: 36px ; color: #60a393;font-weight:bold" > ${res.case.committeeName} </legend>
              <div style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;" >
                  <p style="padding-bottom:0px !important;margin-bottom:0px !important;"> إنه في يوم ${res.decsion.decsionDate}، اجتمعت ${res.case.committeeName} ، بوزارة التجارة بمدينة الرياض للنظر فى المخالفة </p>
                  <p style="padding-top:0px !important;margin-top:0px !important;" > المنسوبة إلى  ${res.case.company ? res.case.company.name : res.case.offenderName} ${offenderTypeName} (${res.case.company ? res.case.company.crnumber : res.case.offenderId})  </p>
              </div>

              <h3 style="margin-bottom: 16px; color: #00524D; font-size: 20px ; line-height: 28px; ">الوقائع</h3>
              <p style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;"> ${res.case.facts}</p>
              <h3 style="color: #00524D; margin-bottom: 16px; font-size: 20px ; line-height: 28px;">الأسباب</h3>
              <p style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;"> ${res.case.reasons} </p>
              <h3 style="color: #00524D; margin-bottom: 16px; font-size: 20px ; line-height: 28px;">القرار</h3>
              <p style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;"> ${res.decsion.decsion} </p>
              <div style="text-align: center; margin-top: 32px;">
                  <div style="display:flex; justify-content: center; gap: 40px ;">
                      <div style="text-align: center;">
                          ${memberOne}
                      </div>
                      <div style="text-align: center;">
                          ${memberTwo}
                      </div>
                      <div style="text-align: center;">
                          <h3 style="margin-bottom: 16px; font-size: 20px ; line-height: 28px; color: rgb(75 85 99);" >رئيس اللجنة</h3>
                          ${SignatueHead}
                          <p> ${headOfCommittee.displayName} </p>
                      </div>
                  </div>
              </div>
              <div style="display:flex;justify-content: center;align-items: center; margin-top: 10px;">
                  <div style="text-align: center;">

                      <img style="width:30%;margin:auto" class="img-fluid for-light" src="../../../../../assets/images/stamp.png" alt="looginpage"/>
                  </div>
              </div>
              
             
            </fieldset>
            ${penalities}
      </div>
  </div>`;
      let contents = `
        <html>
          <head>
            <link href="https://fonts.cdnfonts.com/css/frutiger-lt-arabic" rel="stylesheet">

            <style  type="text/css">
              @media print {
                @page { margin: 0; }
                body { margin: 1.0cm; }
                .pagebreak { page-break-before: always; } 
              }
              body {
                font-family: 'Frutiger LT Arabic', sans-serif;
                direction: rtl;
                background-color: #f9fafb;
              }
              @import url('https://fonts.cdnfonts.com/css/frutiger-lt-arabic');


            </style>
          </head>
          <body > ${body}</body>
        </html>`;
  
      let mywindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      mywindow!.document.open();
      let is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      mywindow!.document.write(contents);
  
      if (is_chrome) {
        setTimeout(function () {
          mywindow!.document.close();
          mywindow!.focus();
          mywindow!.print();
          // mywindow.close();
        }, 1000);
      } else {
        mywindow!.document.close();
        mywindow!.focus();
        mywindow!.print();
        // mywindow.close();
      }
    })


  }
  PrintDecisionWithoutAPI(printInfo) {
    console.log(printInfo);
    let canceledText='';
    if(printInfo.isObjectionAccepted){
      canceledText=`<div style="position: absolute;color: rgba(255, 0, 0,.2);width: 100%;text-align: center;font-size: 200px;transform: rotate(-30deg);top: 200px;left: 0;">ملغي</div>`
    }
    let offenderTypeName;
    let memeberUser: any[] = [];
    let offendersdata: any[] = [];
    let headOfCommittee;
    let displayNameOne = '';
    let displayNameTwo = '';
    let signatureMemberOne;
    let signatureMemberTwo = '';
    let SignatueHead = '';
    let memberOne='';
    let memberTwo='';
    let penalities='';
    let penalitiesprintArr=[];

    if (printInfo.decsionPrintInfo.decsion.decsionTypeId == 1) {
      this.decisionTypeName = "عدم ثبوت المخالفة";
    }
    if (printInfo.decsionPrintInfo.decsion.decsionTypeId == 2) {
      this.decisionTypeName = "ثبوت المخالفة";
    }
    printInfo.decsionPrintInfo.case.offenderTypeId == 1 ? offenderTypeName = "سجل تجاري رقم" : offenderTypeName = "رقم الهوية";
    printInfo.decsionPrintInfo.case.reasons = ((printInfo.decsionPrintInfo.case.reasons == null || printInfo.decsionPrintInfo.case.reasons == "null") ? "" : printInfo.decsionPrintInfo.case.reasons);
    printInfo.decsionPrintInfo.case.facts = ((printInfo.decsionPrintInfo.case.facts == null || printInfo.decsionPrintInfo.case.facts == "null") ? "" : printInfo.decsionPrintInfo.case.facts);
    printInfo.decsionPrintInfo.penalites.map((el, index) => {
        if(el.isFinancial){
            penalitiesprintArr.push(el);
        }
      });
      if(this.decsionTypeId==1){
        penalities='';
      }else{
        if (penalitiesprintArr.length > 0) {
          penalities = `<h3 style="page-break-before: always;color: #00524D; margin-bottom: 16px; font-size: 20px ; line-height: 28px; ">بيانات السداد</h3>
                          <div style="overflow-x: auto;">
                              <table style="border-radius: 10px; min-width: 100%; border-collapse: collapse;">
                                  <thead  >
                                      <tr style="border-bottom: 1px solid #e2dfdf; background-color: #f9f9f9;">
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">نوع العقوبة</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">قيمة العقوبة</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">رقم السداد</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">الاسم</th>
                                          <th style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">رقم الهوية</th>
                                      </tr>
                                  </thead>
                                  <tbody style="background-color: #f9f9f9;">
                                      `;
          let idx : any= 0;
          penalitiesprintArr.map((el, index) => {
              let offendername = '';
              if (el.offenderTypeId == 1) {
                  offendername = printInfo.decsionPrintInfo.case.offenderName;
              }
              else {
                offendername = el.caseOffenderName;
              }
              if(offendername===undefined){
                offendername='-';
              }
              idx = idx + 1;
              penalities = penalities.concat(`<tr >
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${ 'مالية' }</td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${ this.convertNumerals(el.amount)+'ريال'} </td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${ el.sadadNumber}</td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${offendername}</td>
                      <td style="text-align: right; padding-left: 16px ; padding-right: 16px; padding-top:8px; padding-bottom: 8px;">${this.convertNumerals(el.offenderIdentity)}</td>
                  </tr>
              `);

          });
          penalities = penalities + "</tbody></table></div>"
        }
    }
    let offendersdatanames = "";
    if (printInfo.committeeName != "لجنة النظر في مخالفات أحكام نظام الشركات")
        offendersdatanames = offendersdata.join(" و ");
    
      printInfo.decsionPrintInfo.users.map(el => {
          el.committeeRoleId == 7 ? memeberUser.push(el) : headOfCommittee = el;

      });
  headOfCommittee.signture ? SignatueHead = `<img style='width:200px;height:50px;  margin:auto;' src='data:image/png;base64,${ headOfCommittee.signture}'/>` : SignatueHead = '';


    if (printInfo.decsionPrintInfo.decsion.decsion == null) {
        printInfo.decsionPrintInfo.decsion.decsion = "";
    }
    if (memeberUser.length >= 1) {
      memeberUser[0].signture ? signatureMemberOne = `<img style='width:200px;height:50px; margin:auto;' src='data:image/png;base64,${memeberUser[0].signture}'/>` : signatureMemberOne = '';
      if (signatureMemberOne == undefined || signatureMemberOne == 'undefined') {
          signatureMemberOne = "";
      }
      displayNameOne = memeberUser[0].displayName;
      if (displayNameOne == undefined || displayNameOne == 'undefined') {
          displayNameOne = "";
      }
      if(signatureMemberOne !== "" && displayNameOne!== "" ){
          memberOne=`
              <h3 style="margin-bottom: 16px; font-size: 20px ; line-height: 28px; color: rgb(75 85 99);" >عضو</h3>
              ${signatureMemberOne}
              <p>${displayNameOne}</p>
          `;
      }
    }
    else {
        signatureMemberOne = "";
        displayNameOne = "";
    }
    if (memeberUser.length >= 2) {
        memeberUser[1].signture ? signatureMemberTwo = `<img style='width:250px;height:50px;margin:auto;' src='data:image/png;base64,${memeberUser[1].signture}'/>` : signatureMemberTwo = '';
        if (signatureMemberTwo == undefined || signatureMemberTwo == 'undefined') {
            signatureMemberTwo = "";
        }
        displayNameTwo = memeberUser[1].displayName;
        if (displayNameTwo == undefined || displayNameTwo == 'undefined') {
            displayNameTwo = "";
        }
        if(signatureMemberTwo !== "" && displayNameTwo!== "" ){
            memberTwo=`
                <h3 style="margin-bottom: 16px; font-size: 20px ; line-height: 28px; color: rgb(75 85 99);" >عضو</h3>
                ${signatureMemberTwo}
                <p>${displayNameTwo}</p>
            `;
        }
    }
    else {
        signatureMemberTwo = "";
        displayNameTwo = "";
    }
    const body = `<div style="display:flex;justify-content: center;align-items: center; min-height:100vh">
                            <div style="position:relative;background-color:white;padding: 3px; width: 100%;">
                                <div style="display:flex;justify-content: space-between;align-items: center; margin-bottom: 1.5rem;">
                                    <div style="text-align:right" >
                                        <p style="font-size: 14px; color: rgb(107 114 128); line-height:10px; font-weight:600 " >المملكة العربية السعودية</p>
                                        <p style="font-size: 14px; color: rgb(107 114 128);font-weight:600" >وزارة التجارة</p>
                                    </div>
                                    <div>
                                        <img src="../../../../../assets/images/printlogo.png" alt="Ministry of Commerce Logo" class="w-40">
                                    </div>
                                    <div>
                                        <p style="font-size: 14px; color: rgb(107 114 128); line-height:15px; font-weight:600"> تاريخ القرار: ${printInfo.decsionPrintInfo.decsion.decsionDate}</p>
                                        <p style="font-size: 14px; color: rgb(107 114 128); line-height:15px; font-weight:600">رقم القرار: (${printInfo.decsionPrintInfo.decsion.decsionNumber}/${printInfo.decsionPrintInfo.decsion.hijriYear})</p>
                                        <p style="font-size: 14px; color: rgb(107 114 128); line-height:15px; font-weight:600">المخالفة رقم: (${printInfo.decsionPrintInfo.case.caseNumber})</p>
                                    </div>
                                </div>
                                ${canceledText}
                                 <fieldset style="border: #60a393 solid 1px; padding-right: 6px !important; padding-left: 6px !important; border-radius: 10px;">
                                    <legend style="text-align: center; font-size: 24px; line-height: 32px ; padding-left: 36px ; padding-right: 36px ; color: #60a393;font-weight:bold" > ${printInfo.decsionPrintInfo.case.committeeName} </legend>
                                    <div style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;" >
                                        <p style="padding-bottom:0px !important;margin-bottom:0px !important;"> إنه في يوم ${printInfo.decsionPrintInfo.decsion.decsionDate}، اجتمعت ${printInfo.decsionPrintInfo.case.committeeName} ، بوزارة التجارة بمدينة الرياض للنظر فى المخالفة </p>
                                        <p style="padding-top:0px !important;margin-top:0px !important;" > المنسوبة إلى  ${printInfo.decsionPrintInfo.case.offenderName} ${offenderTypeName} (${printInfo.decsionPrintInfo.case.offenderId}) ${offendersdatanames != "" && printInfo.decsionPrintInfo.case.offenderTypeId == 1 ? (" و " + offendersdatanames) : ""}  </p>
                                    </div>

                                    <h3 style="margin-bottom: 16px; color: #00524D; font-size: 20px ; line-height: 28px; ">الوقائع</h3>
                                    <p style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;"> ${printInfo.decsionPrintInfo.case.facts}</p>
                                    <h3 style="color: #00524D; margin-bottom: 16px; font-size: 20px ; line-height: 28px;">الأسباب</h3>
                                    <p style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;"> ${printInfo.decsionPrintInfo.case.reasons} </p>
                                    <h3 style="color: #00524D; margin-bottom: 16px; font-size: 20px ; line-height: 28px;">القرار</h3>
                                    <p style="text-align: right; line-height: 2; color: rgb(55 65 81); margin-bottom: 24px;"> ${printInfo.decsionPrintInfo.decsion.decsion} </p>
                                    <div style="text-align: center; margin-top: 32px;">
                                        <div style="display:flex; justify-content: center; gap: 40px ;">
                                            <div style="text-align: center;">
                                                ${memberOne}
                                            </div>
                                            <div style="text-align: center;">
                                                ${memberTwo}
                                            </div>
                                            <div style="text-align: center;">
                                                <h3 style="margin-bottom: 16px; font-size: 20px ; line-height: 28px; color: rgb(75 85 99);" >رئيس اللجنة</h3>
                                                ${SignatueHead}
                                                <p> ${headOfCommittee.displayName} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display:flex;justify-content: center;align-items: center; margin-top: 10px;">
                                        <div style="text-align: center;">
                
                                            <img style="width:30%;margin:auto" class="img-fluid for-light" src="../../../../../assets/images/stamp.png" alt="looginpage"/>
                                        </div>
                                    </div>
                                </fieldset>
                                ${penalities}

                            </div>
                        </div>`;
    
       let contents = `
       <html>
         <head>
           <link href="https://fonts.cdnfonts.com/css/frutiger-lt-arabic" rel="stylesheet">

           <style  type="text/css">
               @media print {
                   @page { margin: 0; }
                   body { margin: 1.0cm; }
                   .pagebreak { page-break-before: always; } 
               }
               body {
                   font-family: 'Frutiger LT Arabic', sans-serif;
                   direction: rtl;
                   background-color: #f9fafb;
               }
               @import url('https://fonts.cdnfonts.com/css/frutiger-lt-arabic');

              
           </style>
         </head>
         <body > ${body}</body>
       </html>`;

            let mywindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            mywindow!.document.open();
            let is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            mywindow!.document.write(contents);

            if (is_chrome) {
                setTimeout(function () {
                    mywindow!.document.close();
                    mywindow!.focus();
                    mywindow!.print();
                    // mywindow.close();
                }, 1000);
            } else {
                mywindow!.document.close();
                mywindow!.focus();
                mywindow!.print();
                // mywindow.close();
            }



  }


}
